export default __webpack_public_path__ + "static/media/github.489d0671.svg";